<template>
  <div class="row">
    <div class="col-4">
      <div class="position-relative">
        <img 
          class="w-100"
          :src="route?.mapImageUrl" 
          @click="toggleModal" 
        >
        <i class="fa fa-search-plus magnifying-glass color-sachlich-white position-absolute" />
      </div>

      <Modal 
        :show="modal" 
        :close="toggleModal" 
        size="medium"
      >
        <div 
          class="modal-image-container d-flex justify-content-center"
          @click="toggleModal" 
        >
          <img 
            :src="route?.mapImageUrl" 
            class="position-relative w-100 mt-3"
          >
        </div>
      </Modal>
    </div>

    <div class="col">
      <div class="fw-bold">
        {{ cruise?.startDate }} &ndash; {{ cruise?.endDate }}
      </div>
      <div class="fw-bold  lh-base">
        {{ routeNameUpperCase }}
      </div>
      <div>
        {{ cruise?.duration }}&nbsp;Tage {{ firstPortLastPort }} mit {{ ship?.name }}
      </div>
      <div 
        v-if="displayPortList" 
        class="lh-base mt-2"
      >
        {{ portList }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useCruiseStore } from '@/store';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';
import Modal from '../../common/Modal.vue';

export default defineComponent({
  components: { Modal },

  props: {
    displayPortList: { type: Boolean, default: true },
  },

  data: () => {
    return {
      modal: false,
    }
  },

  computed: {
    ...mapState(useCruiseStore, {
      cruise: store => store.cruise,
      route: store => store.route,
      ship: store => store.ship,
    }),
    firstPort() {
      return this.route?.ports.at(0)
    },
    lastPort() {
      return this.route?.ports.at(-1)
    },
    firstPortLastPort() {
      if (this.firstPort === this.lastPort) {
        return `ab/bis ${this.firstPort}`
      }
      return `ab ${this.firstPort} bis ${this.lastPort}`
    },
    portList() {
      const NBSP = '\u00a0'
      return this.route?.ports.join(`${NBSP}> `)
    },
    routeNameUpperCase() {
      return this.route?.name.toUpperCase()
    },
  },
  methods: {
    toggleModal() {
      this.modal = !this.modal
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.image-wrapper {
  position: relative;
  cursor: zoom-in;
  width: 180px;
  flex: 0 0 180px;
}

img {
  cursor: zoom-in;
}

.magnifying-glass {
  font-size: 20px;
  right: 7px;
  bottom: 7px;
}

.large {
  font-size: 14px;
}

.modal-image-container {
  max-height: 65vh;
}
</style>
